/* FAQ : recherche avec surlignage, rubrique active dans le sommaire. */
class FalcoFaq extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[data-faq-search]"); this.clear = this.querySelector("[data-faq-clear]");
    this.status = this.querySelector("[data-faq-status]"); this.empty = this.querySelector("[data-faq-empty]");
    this.topics = [...this.querySelectorAll("[data-topic]")];
    this.questions = [...this.querySelectorAll("[data-question]")].map((li) => ({ li, q: li.querySelector("[data-q]"), a: li.querySelector("[data-a]"), qText: li.querySelector("[data-q]").textContent, aHtml: li.querySelector("[data-a]").innerHTML }));
    this.buildNav();
    this.input?.addEventListener("input", () => this.filter());
    this.clear?.addEventListener("click", () => { this.input.value = ""; this.filter(); this.input.focus(); });
    const obs = new IntersectionObserver((es) => {
      const vu = es.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (vu && !this.input.value.trim()) this.querySelectorAll("[data-nav]").forEach((a) => a.setAttribute("aria-current", String(a.dataset.nav === vu.target.id)));
    }, { rootMargin: "-30% 0px -60% 0px" });
    this.topics.forEach((t) => obs.observe(t));
  }
  buildNav() {
    const nav = this.querySelector("[data-faq-nav]"); const tpl = this.querySelector("template[data-nav-item]");
    if (nav && tpl) {
      nav.innerHTML = "";
      this.topics.forEach((t) => { const li = tpl.content.firstElementChild.cloneNode(true); const a = li.querySelector("a"); a.href = `#${t.id}`; a.dataset.nav = t.id; a.textContent = t.dataset.label || t.id; nav.appendChild(li); });
    }
    const count = this.querySelector("[data-faq-count]"); if (count) count.textContent = String(this.questions.length);
    const ld = { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: this.questions.map((x) => ({ "@type": "Question", name: x.qText.trim(), acceptedAnswer: { "@type": "Answer", text: x.aHtml.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim() } })) };
    const sc = document.createElement("script"); sc.type = "application/ld+json"; sc.textContent = JSON.stringify(ld); document.head.appendChild(sc);
  }
  filter() {
    const q = this.input.value.trim().toLowerCase();
    this.clear.hidden = !q;
    const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const mark = (html) => q ? html.replace(new RegExp(`(?![^<]*>)(${esc(q)})`, "ig"), '<mark class="rounded bg-violet-100 px-0.5 text-graphite">$1</mark>') : html;
    let found = 0;
    this.questions.forEach((x) => {
      const hit = !q || x.qText.toLowerCase().includes(q) || x.aHtml.replace(/<[^>]+>/g, "").toLowerCase().includes(q);
      x.li.hidden = !hit;
      x.q.innerHTML = hit ? mark(x.qText) : x.qText; x.a.innerHTML = hit ? mark(x.aHtml) : x.aHtml;
      const panel = x.li.querySelector(".fold"), btn = x.li.querySelector("[data-fold-trigger]");
      const open = !!q && hit;
      panel.dataset.open = String(open); btn.setAttribute("aria-expanded", String(open));
      btn.querySelector("[data-icon-plus]").hidden = open; btn.querySelector("[data-icon-minus]").hidden = !open;
      if (hit) found++;
    });
    this.topics.forEach((t) => { const any = [...t.querySelectorAll("[data-question]")].some((li) => !li.hidden); t.hidden = !any; const intro = t.querySelector("[data-topic-intro]"); if (intro) intro.hidden = !!q; });
    this.empty.hidden = !(q && found === 0);
    this.status.hidden = !q;
    this.status.textContent = found === 0 ? "Aucune réponse ne correspond." : `${found} réponse${found > 1 ? "s" : ""} trouvée${found > 1 ? "s" : ""}.`;
  }
}
customElements.define("falco-faq", FalcoFaq);
